import React from "react";
import { getStatusBadgeColor } from "./utils/homeUtils";

const HotelStatusCell = ({ roomStatus, loadingStats }) => {
  // Si loadingStats ou roomStatus n'existe pas, afficher des placeholders avec la même structure
  if (loadingStats || !roomStatus || (roomStatus.warning === null && roomStatus.failed === null)) {
    return (
      <div className="space-y-1">
        <span className="px-1.5 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-400">⚠️ -</span>
        <span className="px-1.5 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-400">❌ -</span>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <span className={`px-1.5 py-0.5 text-xs font-medium rounded ${getStatusBadgeColor(roomStatus.warning, "warning")}`}>⚠️ {roomStatus.warning}</span>
      <span className={`px-1.5 py-0.5 text-xs font-medium rounded ${getStatusBadgeColor(roomStatus.failed, "failed")}`}>❌ {roomStatus.failed}</span>
    </div>
  );
};

export default HotelStatusCell;
